import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      validation: {
        errors: {
          email: [],
          old_password: [],
          password: [],
          password_confirmation: [],
          username: [],
        },
        ok: true,
      },
      virgin: {
        email: true,
        old_password: true,
        password: true,
        password_confirmation: true,
        username: true,
      },
    }
  },
  computed: {
    emailInvalid(): boolean {
      const errors = this.validation!.errors!.email
      if (errors) {
        return errors.some((msg: string) => msg === 'is invalid')
      } else {
        return false
      }
    },
    emailTaken(): boolean {
      const errors = this.validation!.errors!.email
      if (errors) {
        return errors.some((msg: string) => msg === 'has already been taken')
      } else {
        return false
      }
    },
    emailNotReadyForNewTreatment(): boolean {
      const errors = this.validation!.errors!.email
      if (errors) {
        return errors.some((msg: string) => msg === 'not ready for new treatment')
      } else {
        return false
      }
    },
    usernameTaken(): boolean {
      const errors = this.validation!.errors!.username
      if (errors) {
        return errors.some((msg: string) => msg === 'has already been taken')
      } else {
        return false
      }
    },
    passwordTooShort(): boolean {
      const errors = this.validation!.errors!.password
      if (errors) {
        return errors.some((msg: string) => msg.startsWith('is too short'))
      } else {
        return false
      }
    },
    passwordMustContainUpperCase(): boolean {
      const errors = this.validation!.errors!.password
      if (errors) {
        return errors.some((msg: string) => msg === 'must contain at least one upper-case letter')
      } else {
        return false
      }
    },
    passwordMustContainDigits(): boolean {
      const errors = this.validation!.errors!.password
      if (errors) {
        return errors.some((msg: string) => msg === 'must contain at least one digit')
      } else {
        return false
      }
    },
    passwordMustContainSymbols(): boolean {
      const errors = this.validation!.errors!.password
      if (errors) {
        return errors.some((msg: string) => msg === 'must contain at least one symbol')
      } else {
        return false
      }
    },
    passwordMustContainLowerCase(): boolean {
      const errors = this.validation!.errors!.password
      if (errors) {
        return errors.some((msg: string) => msg === 'must contain at least one lower-case letter')
      } else {
        return false
      }
    },
    passwordDoesNotMatch(): boolean {
      const errors = this.validation!.errors!.password_confirmation
      if (errors) {
        return errors.some((msg: string) => msg === "doesn't match Password")
      } else {
        return false
      }
    },
    oldPasswordIsWrong(): boolean {
      const errors = this.validation!.errors!.old_password
      if (errors) {
        return errors.some((msg: string) => msg === 'is wrong')
      } else {
        return false
      }
    },
  },
  methods: {
    resetValidation() {
      this.validation = {
        errors: {
          email: [],
          old_password: [],
          password: [],
          password_confirmation: [],
          username: [],
        },
        ok: true,
      }
    },
  },
})
